import React, { useState } from "react";
import SvgImage from "../../Icons/Icons";
import {
  downloadSalaryAction,
  downloadSalaryCreditSheet,
  uploadSalaryAction,
  uploadSalaryCreditSheet,
} from "../../../services/Store/Actions/driverslistActions";
import { useSelector, useDispatch } from "react-redux";
import { toast } from "react-toastify";
import { Button, Form, FormGroup } from "reactstrap";
import BulkSalaryPreviewModal from "../../Modals/BulkSalaryModal";
import { sendAnalitics } from "../../../services/Store/Actions/appActions";
import * as XLSX from "xlsx";
import { Formik } from "formik";
import ShowExcel2 from "../../ManageDriverV2/SubComponents/ShowExcel2";
import PinInput from "react-pin-input";
function BulkSalary() {
  const [open, setOpen] = useState(false);
  const [refresh, setRefresh] = useState(false);
  const [fileSave, setFileSave] = useState(null);
  const [fileUp, setFileUp] = useState(null);
  const [bulkTransfer, setBulkTransfer] = useState(0); 
  const [bulkTransferId, setBulkTransferId] = useState(null); 
  const [loader, setLoader] = useState(false); 
  const [pin,setPin] = useState('')
  // const [typeError, setTypeError] = useState(null);
  const [excelData, setExcelData] = useState(null);
  function handleShow() {
    if (fileSave !== null) {
      console.log("looook", fileSave);
      const workbook = XLSX.read(fileSave, { type: "buffer" });
      const worksheetName = workbook.SheetNames[0];
      const worksheet = workbook.Sheets[worksheetName];
      const data = XLSX.utils.sheet_to_json(worksheet);
      setExcelData(data);
      console.log("dddd", excelData);
    }
  }
  function handleClose() {
    setRefresh(!refresh);
    setOpen(false);
  }
  function toggleModal() {
    setOpen(!open);
    setRefresh(!refresh);
  }
  const [modal2, setModal2] = useState(false);

  const toggleModal2 = () => {
    setModal2(!modal2);
  };

  const showModal = () => {
    setModal2(true);
  };
  const Title = "Bulk Salary";
  const history = Title === "Bulk Salary";
  const dispatch = useDispatch();
  const customId1 = "custom-id-download page";
  const notify1 = () =>
    toast.success("Salary disbursement data was downloaded successfully.", {
      toastId: customId1,
      pauseOnHover: false,
    });
  const customId2 = "custom-id-upload page";
  const notify2 = () =>
    toast.success("Salary disbursement data was uploaded successfully.", {
      toastId: customId2,
      pauseOnHover: false,
    });
  const customId4 = "custom-id-upload page";
  const notify4 = () =>
    toast.success("Salary account details uploaded successfully.", {
      toastId: customId4,
      pauseOnHover: false,
    });
  const customId3 = "custom-id-Salary-dispersed";
  const notify3 = () =>
    toast.success("Salary dispersed successfully to drivers.", {
      toastId: customId3,
      pauseOnHover: false,
    });
  const downloadSal = () => {
    dispatch(
      downloadSalaryAction("", (res) => {
        console.log("downloadSalaryAction", res?.data);
        if (res?.status == 200) {
          const blob = new Blob([res?.data]);
          const link = document.createElement("a");
          link.href = window.URL.createObjectURL(blob);
          link.download = `file.xls`; //name to changed here
          link.click();
          notify1();
        }
      })
    );
  };

  const downloadSalDisbursement = () => {
    dispatch(
      downloadSalaryCreditSheet("", (res) => {
        console.log("downloadSalaryCreditSheet", res);
        if (res?.status == 200) {
          const blob = new Blob([res?.data]);
          const link = document.createElement("a");
          link.href = window.URL.createObjectURL(blob);
          link.download = `file.xls`; //name to changed here
          link.click();
          notify1();
        }
      })
    );
  };

  function handleSalary() {
    setLoader(true)
    dispatch(
      uploadSalaryCreditSheet(
        {
          isRes: false,
          file: fileSave,
          bulkTransferId:bulkTransferId
        },
        (res) => {
            setLoader(false)
            console.log("resp for file upload111", res);
          if (res?.status == 200) {
            // console.log("resp for file upload", res.type);
            const blob = new Blob([res?.data])
            const link = document.createElement("a");
            link.href = window.URL.createObjectURL(blob);
            link.download = `responseFile.xls`; //name to changed here
            link.click();
            notify3();
          }
          else {
            toast.error(res.data?.message||"some error occured")
        }
        }
      )
    );
  }
  function handleCreateWallet() {
    dispatch(
      uploadSalaryAction(
        {
          isRes: false,
          file: fileUp,
        },
        (res) => {
          console.log("resp for file upload", res.type);
          if (res?.type == "success") {
            console.log("entereed");
            notify2();
          }
        }
      )
    );
  }

  return (
    <div>
      <div className="bulkSalary">
        {/* <div className='bankDetails'>
                <div className='Bold heading1'>
                    Add/Update Reciever's Details
                </div>
                <div className='boxShadowIntro container2' style={{padding:'24px 0 18px', margin:'20px 0'}}>
                    <div className='flexStyling1'>
                                <div className='svgTextParent' onClick={downloadSal}>
                                    <div className='svgContainer' style={{margin:'12px 0'}}>
                                        <SvgImage name='Download' />
                                    </div>
                                    <div className='Bold heading3'>Download Template</div>
                                </div>

                                <div className='svgTextParent' style={{position:'relative'}}>
                                    
                                            <label for="file-upload" class="custom-file-upload" style={{width:'100%', display:'flex',flexDirection:'column',justifyContent:'center', alignItems:'center'}}>
                                                <input

                                                    id='file-upload'
                                                    type="file"
                                                    
                                                    // accept="image/*"
                                                    // className='add-attachment-btn-2'
                                                    onChange={async (e) => {
                                                    const img = e?.target.files[0];
                                                    setFileUp(img);
                                                    console.log("image", img?.name);
                                                    notify4();
                                                    }}
                                                />
                                                <div className='svgContainerUp' style={{margin:'12px 0'}}>
                                                    <SvgImage name='Upload' />
                                                </div>
                                        Upload Wallet Details
                                    </label>        
                                </div>
                    </div>
                </div>
                <div style={{display:'flex',justifyContent:'flex-end'}}>
                <Button onClick={fileUp==null ? null :handleCreateWallet} title="Bulk Salary" className={fileUp==null?'payButtonDis':'payButton'}>
                    <span className='Bold heading3' style={{color:'#FFF'}}>Create Salary Wallet</span>
                </Button>
                </div>
            </div> */}
        <div
          className="flexStyling"
          style={{ justifyContent: "space-evenly", alignItems: "center" }}
        >
          {/* <AddBalanceButton Value="Preview Salary" title="Bulk Salary" onclick={handleShow} /> */}
        </div>
        {/* <div className='viewer'>
               {
               excelData ? 
               <>
                    <div className="table-responsive">
                        <table className="table">

                        <thead>
                            <tr>
                            {Object.keys(excelData[0]).map((key)=>(
                                <th key={key}>{key}</th>
                            ))}
                            </tr>
                        </thead>

                        <tbody>
                            {Object.keys(excelData[0]).map((individualExcelData, index)=>(
                            <tr key={index}>
                                {individualExcelData.map((key)=>(
                                <td key={key}>{individualExcelData[key]}</td>
                                ))}
                            </tr>
                            ))}
                        </tbody>

                        </table>
                    </div>
                </> : 
                <>
                    No File Uploaded Yet
                </>
                }
            </div> */}
        <div className="salaryDetails" style={{ marginTop: "45px" }}>
          <div className="Bold heading1">Salary Dispersal</div>
          <div
            className="boxShadowIntro container2"
            style={{ padding: "24px 0 18px", margin: "20px 0" }}
          >
            <div className="flexStyling1">
              <div className="svgTextParent" onClick={downloadSalDisbursement}>
                <div className="svgContainer" style={{ margin: "12px 0" }}>
                  <SvgImage name="Download" />
                </div>
                <div className="Bold heading3">Download Salary Sheet</div>
              </div>


              {/* <div className='svgTextParent'>
                                    <div className='svgContainer' style={{margin:'12px 0'}}>
                                        <SvgImage name='Upload' />
                                    </div>
                                    <label for='file-upload1' class="custom-file-upload">
                                                <input
                                                    id='file-upload1'
                                                    type="file"
                                                    onChange={async (e) => {
                                                    // let fileTypes = ['application/vnd.ms-excel','application/vnd.openxmlformats-officedocument.spreadsheetml.sheet','text/csv']
                                                    const img = e?.target.files[0];
                                                    console.log('aaaaaaaa', img);
                                                    setFileSave(img);
                                                    notify2();
                                                    }}
                                                />
                                        Upload Salary Details
                                    </label>
                                </div> */}
              <div className="svgTextParent" style={{ position: "relative" }}>
                <label
                  for="file-upload1"
                  class="custom-file-upload"
                  style={{
                    width: "100%",
                    display: "flex",
                    flexDirection: "column",
                    justifyContent: "center",
                    alignItems: "center",
                  }}
                >
                  <input
                    id="file-upload1"
                    type="file"
                    // accept="image/*"
                    // className='add-attachment-btn-2'
                    onChange={async (e) => {
                      const img = e?.target.files[0];
                      setFileSave(img);
                      setBulkTransfer(1);
                      console.log("image", img?.name);
                      notify2();
                    }}
                  />
                  <div className="svgContainerUp" style={{ margin: "12px 0" }}>
                    <SvgImage name="Upload" />
                  </div>
                  Upload Salary Details
                </label>
              </div>
            </div>
          </div>
          {bulkTransfer == 1 && (
                <div
                  className="boxShadowIntro container2"
                  style={{ justifyContent: "left" }}
                >
                  <a
                    disabled={loader}
                    style={{ flex: "auto", marginLeft: "6rem" }}
                    href={fileSave}
                  >
                    {fileSave?.name || "test"}
                  </a>
                  <a
              onClick={() => {
                console.log("ckisnkeddd");
                showModal()
              }}
              style={{
                cursor: "pointer",
                textDecoration: "underline",
                color: "blue",
                marginLeft:"20px"
              }}
            >
              View
            </a>
                  <ShowExcel2
        toggle={toggleModal2}
        modal={modal2}
        setModal={setModal2}
        fileSave={fileSave}
      />
      <PinInput
                    length={4}
                    initialValue=""
                    secret
                    onChange={(val)=>{
                      // handleChange("pin")
                    console.log("val...",val)
                    setPin(val)
                    }}
                    type="numeric"
                    value={pin}
                    // onBlur={handleBlur("pin")}
                    // touched={touched.pin}
                    // errors={errors.pin}
                    inputMode="number"
                    style={{
                      marginTop: "20px",
                     margin: "2rem",
                     marginLeft:"6rem"
                    }}
                    inputStyle={{
                      border: "1px solid #A7A7A7",
                      borderRadius: "8px",
                      marginRight: "5px",
                    }}
                    autoSelect={true}
                    regexCriteria={/^[ A-Za-z0-9_@./#&+-]*$/}
                  />

      

      

                  <div style={{ margin: "1rem" }}>
                    {/* <text
                            style={{"margin-right":"1rem"}}
                            >
                                Bulk TransferId: 
                            </text> */}
                    <input
                      type="text"
                      className="form-control"
                      name="bulkTransferId"
                      placeholder="Enter Unique TransferId"
                      disabled={loader}
                      onChange={(e) => {
                        console.log(e.target.value);
                        setBulkTransferId(e.target.value);
                      }}
                    />
                  </div>
                  <Button
                    onClick={fileSave == null ? null : handleSalary}
                    title="Bulk Salary"
                    className={fileSave == null ? "payButtonDis" : "payButton"}
                    style={{marginLeft:"6rem"}}
                  >
                    <span className="Bold heading3" style={{ color: "#FFF" }}>
                      Pay Bulk Salary
                    </span>
                  </Button>
                </div>
              )}
          {/* <div style={{ display: "flex", justifyContent: "flex-end" }}>
            <Button
              onClick={fileSave == null ? null : handleSalary}
              title="Bulk Salary"
              className={fileSave == null ? "payButtonDis" : "payButton"}
            >
              <span className="Bold heading3" style={{ color: "#FFF" }}>
                Pay Bulk Salary
              </span>
            </Button>
          </div> */}
        </div>
      </div>
    </div>
  );
}

export default BulkSalary;
